export const editableFieldFrCATranslations = {
  editableFieldEdit: "Modifier {{label}} : {{value}}",
  editableFieldEditing: "Modification de {{label}}",
  editableFieldCancelled: "Modification annulée. {{label}} : {{value}}",
  editableFieldSaved: "{{label}} enregistré : {{value}}",
  editableFieldUnchanged: "{{label}} inchangé : {{value}}",
  editableFieldNotSet: "Non défini",
  editableFieldSelect: "Sélectionner...",
  editableFieldRequired: "{{label}} est obligatoire",
  editableFieldMinLength: "{{label}} doit contenir au moins {{min}} caractères",
  editableFieldMaxLength: "{{label}} doit contenir moins de {{max}} caractères",
  editableFieldSaveFailed: "Échec de l’enregistrement",
};
